import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export interface RASResult {
  data?: string[][];
  loading: boolean;
  error?: string;
}

export const useAuthorizationByRole = (
  username?: string,
  year?: string,
  quarter?: number,
  enabled: boolean = true
): RASResult => {
  const client = useMyProviderDataClient();

  const [data, setData] = useState<string[][]>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (!enabled || !username || !year) return;

    const load = async () => {
      try {
        setLoading(true);
        setError(undefined);

        const ntName = "positive\\"+username;
        const res = await client.get(
          "/EmployeeInformation/RasBonusInfo",
          { params: { username: ntName, year, quarter } }
        );

        const result = res.data;

        if (!Array.isArray(result) || result.length === 0) {
          setData(undefined);
          return;
        }
        console.log("Authorization by Role API result:", result);
        const formatted = result.map((item: any) => [
          item.clientName ?? "",
          String(item.analystRequiredHours ?? 0),
          String(item.myProvidedHours ?? 0),
          String(item.assistantHoursAuthorized ?? 0),
          String(item.assistantHoursProvided ?? 0),
          `${((item.assistantProvidedPercent ?? 0)).toFixed(1)}%`,
        ]);

        setData(formatted);
      } catch (err) {
        console.error(err);
        setError("Failed to load Authorization data.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [username, year, quarter, enabled, client]);

  return { data, loading, error };
};